module.exports = __webpack_public_path__ + "img/chongci_ps_11.864dda4d.jpg";